import { Card, FlexBox, Typography, responsive } from '@vp/swan';
import type { FC } from 'react';
import { Request } from '@99designs/graph-utils/types';
import { __ } from '@99designs/i18n';
import { PENDING_FULFILMENT_STATUS } from '../utils/constants';
import { RequestCardImage } from './RequestCardImage';
import { RequestCardSummary } from './RequestCardSummary';

const ResponsiveFlexBox = responsive(FlexBox);

interface ProcessingCardProps {
    request: Request;
}

const ProcessingCard: FC<ProcessingCardProps> = ({ request }) => {
    const title = request.expertService?.title ?? '';
    const productName = request.expertService?.printProduct?.name ?? '';

    return (
        <Card bordered>
            <ResponsiveFlexBox
                xs={{
                    flexDirection: 'column',
                    gap: 'between-subsections',
                    alignItems: 'center',
                }}
                sm={{
                    flexDirection: 'row',
                    gap: 'between-sections',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                }}
            >
                {/* Project image thumbnail */}
                <RequestCardImage
                    imgSrc="https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/expert_services/Dashboard/Draft_brief_graphic_617_570.svg"
                    imgAlt={__('Order Processing')}
                />

                {/* Project details */}
                <ResponsiveFlexBox
                    style={{ flex: '1 1 100%' }}
                    xs={{
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 'between-actions',
                    }}
                    sm={{ alignItems: 'flex-start' }}
                >
                    <RequestCardSummary
                        title={title}
                        createdAt={request.createdAt}
                        productName={productName}
                        status={PENDING_FULFILMENT_STATUS}
                    />
                    <Typography fontSkin="body-standard">
                        {__('Your order is being processed. Design work starts shortly.')}
                    </Typography>
                </ResponsiveFlexBox>
            </ResponsiveFlexBox>
        </Card>
    );
};

export { ProcessingCard };
